import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonLink from './ButtonLink';
import { TimeEntryCardLayout } from './TimeEntryCardLayout';
import { TimeEntryReadOnlyReason } from '../logic';

type Props = {
  readonlyReasons: TimeEntryReadOnlyReason[];
  onAddNewTimeEntryClick: () => void;
};

const EmptyTimeEntryContainer: React.FC<Props> = ({
  readonlyReasons,
  onAddNewTimeEntryClick,
}) => {
  const { t } = useTranslation();
  const readonly = readonlyReasons.length > 0;
  const restrictedFutureEntry = readonlyReasons.includes(
    'restrictedFutureEntries',
  );

  return (
    <TimeEntryCardLayout>
      {!readonly ? (
        <ButtonLink
          title={t('timeTrackingNew.dayCard.addNewTimeEntry')}
          onClick={onAddNewTimeEntryClick}
        />
      ) : (
        <span>
          {restrictedFutureEntry
            ? t('timeTrackingNew.dayCard.restrictedFutureEntries')
            : t('timeTrackingNew.dayCard.noEntries')}
        </span>
      )}
    </TimeEntryCardLayout>
  );
};

export default EmptyTimeEntryContainer;
